import React from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

const MotionLoading = ({ children, loading }) => (
  <motion.div
    animate={!loading ? 'open' : 'closed'}
    initial={{ opacity: 0 }}
    variants={{
      closed: { opacity: 0, y: 20 },
      open: { opacity: 1, y: 0 },
    }}
    transition={{ duration: 0.5 }}
    data-testid="motion-loading"
  >
    {children}
  </motion.div>
);

MotionLoading.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default MotionLoading;
